module.exports = __webpack_public_path__ + "static/check-4238788cf7ef257620935ba283d210ff.png";